import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import Link from '@/links';
import {withNeutral800} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';

const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3UpperNeutral800 = withNeutral800(
  withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)))
);
const DivMargined = withMarginBottomDoubleXlToXl('div');

const AdditionalFeaturesSection = () => {
  const t = useTranslations('features.additionalFeatures');

  const ServiceAndSupportFeaturesArray = t.raw('serviceSupport.features');
  const OnboardingAndImplementationFeaturesArray = t.raw('onboardingImplementation.features');
  const SecurityAndComplianceFeaturesArray = t.raw('securityCompliance.features');

  return (
    <SectionPadding>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" middle="xs">
            <Col xs={12}>
              <H2>{t('title')}</H2>
            </Col>
          </RowMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">{t('serviceSupport.title')}</H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {ServiceAndSupportFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#EEF8FF">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('onboardingImplementation.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {OnboardingAndImplementationFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#EEF8FF">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('securityCompliance.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {SecurityAndComplianceFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#EEF8FF">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>

        <Row center="xs">
          <Col xs={12}>
            <Link
              href="/static/downloads/Workable-features.pdf?1.3"
              variant="secondary-no-gradient"
              target="_blank"
              linkTitle="Download Workable features pdf">
              {t('downloadLink')}
            </Link>
          </Col>
        </Row>
      </Container>
    </SectionPadding>
  );
};

export default AdditionalFeaturesSection;
